import { render, staticRenderFns } from "./UcRentalFormServicesTable.yaml?vue&type=template&id=8a1143c8&component"
import script from "./UcRentalFormServicesTable.yaml?vue&type=script&lang=ts&component"
export * from "./UcRentalFormServicesTable.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports